import { render, staticRenderFns } from "./ResidenceForm.vue?vue&type=template&id=2779b1c0&scoped=true"
import script from "./ResidenceForm.vue?vue&type=script&lang=js"
export * from "./ResidenceForm.vue?vue&type=script&lang=js"
import style0 from "./ResidenceForm.vue?vue&type=style&index=0&id=2779b1c0&prod&scoped=true&lang=css"
import style1 from "./ResidenceForm.vue?vue&type=style&index=1&id=2779b1c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2779b1c0",
  null
  
)

export default component.exports